export default "__VITE_ASSET__BgUgzwSH__"